import { useMemo } from 'react'
import { TypeServico } from '@/lib/enums'
import { useCurrentUser, usePermissions } from '@/features/auth/state/auth'
import { Product } from '../state/selectProduct'
import { useFetchProductById } from '../services'
import { campoParaTipoServico, camposFiltrados, produtosLabelsTypeContract } from '../utils'

import { TypeContrato } from '@/features/agreement/utils/enum'

export default function useProductsByRegime(cnpjcpf: string) {
  const { data: products = [], isLoading } = useFetchProductById(cnpjcpf)

  const user = useCurrentUser()
  const permissions = usePermissions()
  const cargosRestritos = ['ANALISTA', 'JURIDICO', 'FINANCEIRO'] as const
  const isAdminRestrito = user?.typeUser === 'ADMIN' && cargosRestritos.includes(user.typeCargo as any)

  const allowedTypes = useMemo<TypeServico[]>(() => {
    if (!isAdminRestrito || !permissions) return []
    return camposFiltrados
      .filter(campo => permissions[campo])
      .map(campo => campoParaTipoServico[campo]) as TypeServico[]
  }, [isAdminRestrito, permissions])

  const visibleProducts = useMemo(() => {
    if (!isAdminRestrito) return products
    return products.filter((p: { typeServico: TypeServico }) => allowedTypes.includes(p.typeServico))
  }, [products, isAdminRestrito, allowedTypes])

  const groupedByRegime = useMemo<Record<string, Product[]>>(() => {
    return visibleProducts.reduce(
      (acc: any, prod: Product) => {
        const regimeKey = produtosLabelsTypeContract[prod.typeRegime as TypeContrato]
        if (!acc[regimeKey]) acc[regimeKey] = []
        acc[regimeKey].push(prod)
        return acc
      },
      {} as Record<string, Product[]>
    )
  }, [visibleProducts])

  return { data: groupedByRegime, isLoading }
}
